class BoxTypeService {
  constructor() {
    this.data = [
      {
        label: 'Cryobox',
        code: '64d3a2a80000000000147fbd',
      },
      {
        label: 'Not Applicable',
        code: 'none',
      },
    ];
  }

  async getList() {
    return new Promise((res) => {
      res(this.data);
    });
  }

  getOne(id) {
    return new Promise((res) => {
      const boxType = this.data.find((datum) => datum.code === id);
      res(boxType);
    });
  }
}

export default BoxTypeService;
